export default __webpack_public_path__ + "static/media/822.7a2b067a.png";